// extracted by mini-css-extract-plugin
export var title = "typography-module--title--2e462";
export var title__space_none = "typography-module--title__space_none--7a5a4";